<template>
  <div class="mine">
    <el-tabs v-model="activeName" class="customTabs">
      <el-tab-pane label="我的预约" name="first" class="items">
        <div class="orderItems">
          <div
            v-for="(item, index) in recordPage.recordsList"
            :key="index"
            class="orderItem"
            @click="orderDetial(item.id,item.makeDateStr,item)"
          >
            <div class="time">
              <p>{{getTimeFormat(item.makeDateStr)[0]}}</p>
              <p>{{getTimeFormat(item.makeDateStr)[1]}}</p>
              <p>{{item.startMinuteStr}} - {{item.endMinuteStr}}</p>
            </div>
            <img :src="item.exhTitleImg" />
            <div class="detialInfo">
              <p>{{item.exhName}}</p>
              <p>时间：{{item.makeDateStr}}</p>
              <p>地点：{{item.areaAddress}}</p>
              <p v-if="item.status=='2'">状态：审核未通过</p>
              <p v-if="item.status=='1'">状态：待审核</p>
              <p v-if="item.status=='3'">状态：预约成功</p>
              <p v-if="item.status=='0'">状态：取消预约</p>
              <div v-if="item.message!=''" class="bohui">
                <p>驳回原因：</p>
                <p class="content">{{item.message}}</p>
              </div>
              <div>
                <p>简介：</p>
                <p>{{item.exhRemark}}</p>
              </div>
            </div>
            <div class="btsgroup gray status-item" v-if="item.status =='0'">
              <button>已取消</button>
            </div>
            <div class="btsgroup blue status-item" v-if="item.status =='1'">
              <button>待审核</button>
            </div>
            <div class="btsgroup red status-item" v-if="item.status =='2'">
              <button>驳回</button>
            </div>
            <div class="btsgroup green status-item" v-if="item.status =='3'">
              <button>预约成功</button>
            </div>
            <div class="btsgroup red status-item" v-if="item.breach =='1'">
              <button>{{item.breachName}}</button>
            </div>
            <div class="btsgroup again" v-if="item.status == '2'">
              <button @click.stop="againOrder(item)">再次预约</button>
            </div>
            <div class="btsgroup cancel" v-if="isCancel(item)">
              <button @click.stop="oprateActivity(item, 0)">取消预约</button>
            </div>
            <!-- <p @click.stop>
              <el-upload class="upload-demo" action :http-request="uploadImg2" :limit="1">
                <div class="btsgroup">
                  <button>签到</button>
                </div>
              </el-upload>
            </p>-->
            <!-- <div class="btsgroup" v-if="item.OUTTIME =='' && item.SIGNTIME !=''">
              <button @click.stop="oprateActivity(item.ID, 2)">
                <i class="el-icon-s-claim"></i>
                <p>签退</p>
              </button>
            </div>-->
          </div>
          <div class="nothing wait" v-if="recordPage.nothing">
            <img src="../../assets/images/timg1.png" />
            <span>不是吧~ 你竟然没有预约过活动</span>
          </div>
          <div class="loading wait" v-if="recordPage.loading">
            <img src="../../assets/images/loading.gif" />
            <span>正在找你的预约记录~</span>
          </div>
        </div>
        <!-- <el-pagination
          v-if="!recordPage.nothing"
          class="customPage"
          background
          layout="prev, pager, next"
          :total="recordPage.totalCount"
          @current-change="getOrders"
          :page-size="recordPage.pageSize"
          :pager-count="13"
        ></el-pagination> -->
      </el-tab-pane>
      <el-tab-pane label="我的违约" name="second" class="items">
        <div class="orderItems">
          <div
            v-for="(item, index) in breachPage.BreachList"
            :key="index"
            class="orderItem"
            @click="orderDetial(item.id, item.makeDateStr)"
          >
            <div class="time">
              <p>{{getTimeFormat(item.makeDateStr)[0]}}</p>
              <p>{{getTimeFormat(item.makeDateStr)[1]}}</p>
              <p>{{getTimeFormat(item.makeDateStr)[2]}}</p>
            </div>
            <img :src="item.areaImgPath" />
            <div class="detialInfo">
              <p>{{item.exhName}}</p>
              <p>时间：{{item.makeDateStr}}</p>
              <p>地点：{{item.areaAddress}}</p>
              <div>
                <p>简介：</p>
                <p>{{item.exhRemark}}</p>
              </div>
              <p>
                违约原因：
                <span style="color: #ae0c2a">签到或者签退异常</span>
              </p>
            </div>
          </div>
          <div class="nothing wait" v-if="breachPage.nothing">
            <img src="../../assets/images/timg1.png" />
            <span>太棒了~ 你竟然没有违约记录</span>
          </div>
          <div class="loading wait" v-if="breachPage.loading">
            <img src="../../assets/images/loading.gif" />
            <span>正在找你的违约记录~</span>
          </div>
        </div>
        <!-- <el-pagination
          v-if="!recordPage.nothing"
          class="customPage"
          background
          layout="prev, pager, next"
          :total="breachPage.totalCount"
          @current-change="getBreach"
          :page-size="breachPage.pageSize"
          :pager-count="13"
        ></el-pagination> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { myRecords, findAllBreachPage, cancelMake, uploadFile } from '@/libs/api'
import QrCode from 'qrcode-decoder'
export default {
  data() {
    return {
      userInfo: this.$store.state.accountInfo,
      activeName: 'first',
      recordPage: {
        currentPage: 1,
        recordsList: [],
        totalCount: 1000,
        pageSize: 500,
        loading: true,
        nothing: false
      },
      party: sessionStorage.getItem('party'),
      breachPage: {
        currentPage: 1,
        BreachList: [],
        totalCount: 1000,
        pageSize: 100,
        loading: true,
        nothing: false
      }
    }
  },
  methods: {
    uploadImg2: function (file) {
      let qr = new QrCode();
      let url = this.getObjectURL(file);
      qr.decodeFromImage(url).then((res) => {
        //打印结果为 解析出来的 二维码地址
        this.qrId = res.data;
        // console.log('二维码识别结果：', res.data);
        this.confirmDialog();
      }).catch(err => {
        this.confirmDialog();
      });
    },
    //获取二维码地址
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    orderDetial: function (id, exhId) {
      this.$router.push({ name: "orderDetial", query: { id: id, exhId: exhId } })
    },
    getTimeFormat: function (time) {
      var timeFo = []
      timeFo.push(time.substring(8, 10));
      timeFo.push(time.substring(0, 7));
      timeFo.push(time.substring(11, 24));
      return timeFo
    },
    isCancel (item) {
      /* 
        signType // 签到状态 0未签到,1无需签到,2已签到
        status // 0取消预约,1待审核,2驳回,3已预约
        breach // 违约
      */
      if (item.signType == 2 || [0, 2].includes(item.status) || item.breach == 1) return false
      
      return new Date() <= new Date(`${item.makeDateStr} ${item.startMinuteStr}`)
    },
    isCancelOrder(item, type = 1) {
      let flag = 2;
      // console.log(item.exhName, item.status, item.breach);
      if (item.status == 3 && item.breach == 0) {
        //预约状态为已预约并且没有违规，也就是还在签到时间内
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
        // console.log(new Date(`${year}/${month}/${day}`).getTime(), new Date(item.makeDateStr.replace(/-/g, '/') + " " + item.startMinuteStr).getTime());
        if (new Date(`${year}/${month}/${day}`).getTime() <= new Date(item.makeDateStr.replace(/-/g, '/') + " " + item.startMinuteStr).getTime()) {
          flag = 1;
        }
        if (flag == type) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getOrders: function () {
      myRecords(this.recordPage.currentPage, this.recordPage.pageSize, 1).then(data => {
        if (data.status) {
          // console.log('我的预约记录：', data.data.pageList);
          this.recordPage.recordsList = data.content.pageList
          this.recordPage.totalCount = data.content.count
          if (this.recordPage.recordsList.length == 0) {
            this.recordPage.nothing = true;
          }
        } else {
          this.recordPage.nothing = true;
        }
        this.recordPage.loading = false;
      });
    },
    getBreach: function () {
      findAllBreachPage(this.breachPage.currentPage, this.breachPage.pageSize).then(data => {
        if (data.status) {
          // console.log('我的违约记录：', data.content.pageList);
          this.breachPage.BreachList = data.content.pageList
          this.breachPage.count = data.content.totalCount
          if (this.breachPage.BreachList.length == 0) {
            this.breachPage.nothing = true;
          }
        } else {
          this.breachPage.nothing = true;
        }
        this.breachPage.loading = false;
      });
    },
    oprateActivity (item, type) {
      this.$confirm(`你正在取消展览预约 "${item.exhName}"，确定吗？`, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //取消预约
          cancelMake(item.id).then(res => {
            if (res.status) {
              this.$alert('取消预约成功')
              this.getOrders();
            } else {
              this.$alert(res.message)
            }
          }).catch(err => {
            this.$alert('取消失败，请联系管理员')
          })
        }).catch(() => { });
      
      // oprateActivity(id, type).then(res => {
      //   if (res.status) {
      //     var message = "";
      //     if (type == 1) {
      //       message = "签到成功, 快去参加活动吧！";
      //     } else if (type == 0) {
      //       message = "取消预约成功, 下次再约吧！";
      //     } else if (2) {
      //       message = "签退成功, 期待与你的下次相遇！";
      //     }
      //     this.$alert(message, '成功', {
      //       confirmButtonText: '确定',
      //       callback: action => {
      //         this.getOrders();
      //       }
      //     })
      //   } else {
      //     this.$alert('操作失败！请稍后再试！', '提示', {
      //       confirmButtonText: '确定',
      //       callback: action => {
      //       }
      //     })
      //   }
      // })
    },
    // 再次预约
    againOrder(item) {
      this.$router.push({ path: 'activityDetial', query: { id: item.exhId, makeLogId: item.id } })
    }
  },
  created() {
    this.getOrders();
    this.getBreach();
  }
}
</script>
<style lang="less">
  .bohui{
    word-break: break-word;
   
    .content{
      word-break: break-word;
      font-size: 12px !important;
      color: white !important;
    }
  }
.mine {
  .customTabs.el-tabs {
    .el-tabs__item {
      color: white;
    }
    .el-tabs__nav {
      float: right;
    }
    .el-tabs__item.is-active {
      color: #ae0c2a;
    }
    .el-tabs__active-bar {
      background-color: #ae0c2a;
    }
    .el-tabs__nav-wrap::after {
      content: '';
      width: 0%;
    }
    .items {
      overflow-y: hidden;
      height: 70vh;

      display: flex;
      flex-direction: column;
      .orderItems {
        flex: 1;
        overflow-x: hidden;
        overflow-y: scroll;
        padding-right: 4px;
        .orderItem {
          display: flex;
          position: relative;
          overflow: hidden;
          padding: 15px;
          background-color: #1a1a1ac7;
          padding-top: 10px;
          padding-bottom: 10px;
          margin-bottom: 4vh;
          padding-top: 15px;
          .time {
            text-align: center;
            color: white;
            padding-left: 10px;
            padding-right: 25px;
            p:first-child {
              font-size: 80px;
              font-weight: bolder;
              padding-bottom: 5px;
              line-height: 1;
              border-bottom: 2px solid white;
              color: white;
            }
            p:nth-child(2) {
              color: #8d8d8d;
              line-height: 2.4;
            }
            p:last-child {
              line-height: 1;
            }
          }
          img {
            height: 15vh;
          }
          .detialInfo {
            padding-left: 20px;
            color: white;
            font-size: 12px;
            flex: 1;
            p {
              line-height: 1;
              margin-bottom: 1vh;
            }
            > p:first-child {
              font-size: 30px;
              line-height: 1;
              margin-bottom: 2vh;
            }
            div {
              display: flex;
              p:last-child {
                color: #7f7f7f;
                flex: 1;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 1.4;
              }
            }
          }
          .btsgroup {
            width: 260px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            border-radius: 5px;
            overflow: hidden;
            button {
              width: 70%;
              height: 50px;
              display: flex;
              align-items: center;
              border-radius: 8px;
              justify-content: center;
              outline: none;
              border: none;
              color: white;
              margin-bottom: 1vh;
              background-color: black;
              border: 1px solid #ccc;
              background-color: #ae0c2a;
              border: none;
              i {
                font-size: 18px;
                margin-right: 5px;
              }
            }
          }
          .cancel {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .again {
            position: absolute;
            bottom: 20px;
            right: 20px;
          }
          .status-item {
            transform: rotate(45deg);
            width: 500px;
            height: 70px;
            position: absolute;
            right: -211px;
            top: 0;
            button {
              width: 70%;
              height: 100%;
            }
          }
          .gray {
            // background-color: gray;
            border: none;
            button {
              color: white;
              background: gray;
            }
          }
          .blue {
            button {
              color: white;
              background: #409eff;
            }
          }
          .green {
            button {
              color: white;
              background: #16b777;
            }
          }
          .red {
            button {
              color: white;
              background: #ae0c2a;
            }
          }
        }

        .wait {
          //background-image: url("~@/assets/images/registerbg.jpg");
          //background-repeat: no-repeat;
          //background-position: bottom;
          //background-color: #f1eee7;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          letter-spacing: 2px;
          background-color: white;
          border-radius: 5px;
          i {
            font-size: 40px;
            color: white;
            margin-top: 20vh;
            margin-bottom: 20px;
          }
          span {
            font-size: 24px;
            color: #c1c1c1;
          }
          img {
            width: 20%;
            margin-top: 10vh;
            margin-bottom: 3vh;
          }
        }
      }
      .customPage {
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>
<style scoped>
.orderItems::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}
.orderItems::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}
.orderItems::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}
.orderItems::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}
.orderItems::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}
.orderItems::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}
.orderItems::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}
.orderItems {
  scrollbar-arrow-color: #f4ae21; /**/ /*三角箭头的颜色*/
  scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**/ /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
}
</style>
<style>
.el-pagination {
  padding: 0;
}
.el-pagination > button {
  background-color: #1a1a1ad1;
}
.el-pagination .el-pager li {
  background-color: #1a1a1ad1 !important;
  color: white;
}
.el-pagination .el-pager li.active {
  color: #ae0c2a !important;
  cursor: default;
}
.el-pagination button {
  background-color: #1a1a1ad1 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ae0c2a;
}
</style>



// WEBPACK FOOTER //
// src/components/single/mine.vue